import * as XLSX from "xlsx";
import type { ParsedFileData, ParsedSheetData, ParsedCellData } from "../types";

export async function parseXlsxFile(file: File): Promise<ParsedFileData> {
  const arrayBuffer = await file.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: "array" });

  const sheets: ParsedSheetData[] = workbook.SheetNames.map((sheetName) => {
    const worksheet = workbook.Sheets[sheetName];
    const cells: Record<string, ParsedCellData> = {};

    const ref = worksheet["!ref"];
    if (!ref) return { sheetName, cells };

    const range = XLSX.utils.decode_range(ref);
    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
        const cell = worksheet[cellRef];
        if (cell && cell.v !== undefined && cell.v !== null) {
          cells[cellRef] = {
            cell: cellRef,
            rawValue: cell.v,
            formattedValue: cell.w ?? String(cell.v ?? ""),
            sheetName,
          };
        }
      }
    }

    return { sheetName, cells };
  });

  return {
    fileName: file.name,
    fileFormat: "xlsx",
    sheets,
  };
}

export function findSheetByNameOrIndex(
  parsedFile: ParsedFileData,
  sheetName?: string,
  sheetIndex?: number
): ParsedSheetData | null {
  if (sheetName) {
    return parsedFile.sheets.find((s) => s.sheetName === sheetName) ?? null;
  }
  if (sheetIndex !== undefined && sheetIndex < parsedFile.sheets.length) {
    return parsedFile.sheets[sheetIndex] ?? null;
  }
  return parsedFile.sheets[0] ?? null;
}

export function getCellValue(
  sheet: ParsedSheetData,
  cellRef: string
): unknown | null {
  const cellData = sheet.cells[cellRef];
  return cellData?.rawValue ?? null;
}
